import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DesignAngularKitModule } from 'design-angular-kit';
import { environment } from '../../../environments/environment';
import { RequestDto, SettingDto, SubSettingDto } from '../../models/request.dto';
import { RequestService } from '../../services/request.service';
import { AuthService } from '../../services/auth.service';

interface Actor {
  id: string;
  code: string;
  name: string;
}

@Component({
  selector: 'app-change-setting',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule, FormsModule],
  templateUrl: './change-setting.component.html',
  styleUrl: './change-setting.component.scss'
})
export class ChangeSettingComponent {
  @Input() request!: RequestDto;

  @Output() changeConfirmed = new EventEmitter<{ selectedSubsetting: number }>();
  @Output() cancelled = new EventEmitter<void>();

  settings: SettingDto[] = [];

  selectedSetting: any | undefined;
  selectedSubsetting: number | null = null;

  constructor(private http: HttpClient, private requestService: RequestService, private authService: AuthService) { }

  ngOnInit(): void {
    this.selectedSetting = null;
    this.selectedSubsetting = null;

    this.getSettings();
  }

  getSettings() {
    if (this.request.status.code === 'BOZ') {
      this.requestService
        .getSettings(this.authService.userInfo.username)
        .subscribe((response) => {
          if (response) {
            this.settings = response as SettingDto[];
          }
        });
    } else {
      this.requestService
        .getAssociatedSettingsForTransition(this.request.uuid)
        .subscribe((response) => {
          if (response) {
            this.settings = response as SettingDto[];
          }
        });
    }

  }

  getSubsettings(): SubSettingDto[] {
    return (
      this.settings.find((setting) => setting.code === this.selectedSetting)
        ?.subSettings || []
    );
  }

  onSelectedSetting(event: any) {
    if (this.getSubsettings()?.length === 1) {
      this.selectedSubsetting = this.getSubsettings()[0].id;
    }
  }

  confirm(): void {
    if (this.selectedSubsetting) {
      this.changeConfirmed.emit({
        selectedSubsetting: this.selectedSubsetting
      });
    }
  }

  cancel(): void {
    this.cancelled.emit();
  }
}
